export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Skriv ett inlägg...',
  blogsFeedSearchInputPlaceholder: 'Sök',
  blogsFeedPostOwnerCurtainEditTitle: 'Redigera inlägg',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Ta bort inlägg',
  blogsFeedEditedPostSavedAlertText: 'Inlägget sparades!',
  blogsFeedEditedPostDeletedAlertText: 'Inlägget har tagits bort!',
  blogsFeedShareCurtainOptionTitle: 'Kopiera länk',
  blogsFeedPostLinkCopiedAlertText: 'Länken kopierades!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Kopiera länk',
  blogsFeedOthersPosLinkCopiedAlertText: 'Länken kopierades!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Rapportera innehåll',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Ta bort inlägg',
  blogsFeedPostDeletePopupTitle: 'Ta bort',
  blogsFeedPostDeletePopupText: 'Är du säker på att du vill ta bort detta inlägg?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Avbryt',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Bekräfta',
  blogsFeedPostDeeletedAlertText: 'Inlägget har tagits bort!',
  blogsPostDetailsHeaderTitle: 'Inlägg',
  postFeedPostLikesText: 'Gillar',
  postFeedPostCommentsText: 'Kommentarer',
  postFeedPostNoLikesText: 'Det finns inga gillanden ännu',
  postFeedPostLeaveFirstLikeText: 'Du kan vara den första att gilla',
  blogsFeedPostDetailsNoCommentsText: 'Det finns inga kommentarer ännu',
  blogsFeedPostDetailsFirstCommentText: 'Du kan vara den första att kommentera',
  blogsFeedPostDetailsShareOptionTitle: 'Kopiera länk',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Länken kopierades!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Kopiera länk',
  blogsFeedPostDetailsCopiedAlertText: 'Länken kopierades!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Rapportera innehåll',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Rapportera',
  blogsPostDetailsReportedCurtainText: 'Innehållet har rapporterats',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Redigera kommentar',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Ta bort kommentar',
  blogsPostDetailsEditedCommentSavedAlertText: 'Kommentaren sparades!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Ta bort kommentar',
  postDetailsOtherUsersCommentDeletadAlertText: 'Kommentaren har tagits bort!',
  postDetailsDeleteCommentPopupTitle: 'Ta bort',
  postDetailsDeleteCommentPopupText: 'Är du säker på att du vill ta bort denna kommentar?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Avbryt',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bekräfta',
  postDetailsCommDeletedAlertText: 'Kommentaren har tagits bort!',
  postDetailsCommentUserCurtainOptionTitle: 'Rapportera kommentar',
  blogsCreatePostCurtainTitle: 'Nytt inlägg',
  blogsCreatePostCurtainBodyPlaceholder: 'Skriv din text här...',
  blogsCreatePostPublishButtonTitle: 'Publicera',
  blogsCreatePostUploadSlallerImageAlertText: 'Du kan ladda upp högst {size} MB åt gången',
  blogsPostSavedAlertText: 'Inlägget sparades!',
  blogsCreatePostAddLocationCurtainTitle: 'Plats',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Platsnamn',
  blogsCreatePostEditLocationCurtainText: 'Redigera plats',
  blogsDeleteLocation: 'Ta bort plats',
  blogsDiscardPostPopupTitle: 'Kasta',
  blogsDiscardPostPopupText: 'Vill du kasta detta utkast?',
  blogsDiscardPostPopupCancelButtonTitle: 'Avbryt',
  blogsDiscardPostPopupCofirmButtonTitle: 'Bekräfta',
  blogsNewPostCreatePollTitle: 'Skapa enkät',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Rubrik',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Alternativ',
  blogsNewPostCreatePollAddButtonTitle: 'Lägg till alternativ',
  blogsNewPostCreatePollCreateButtonTitle: 'Skapa',
  blogsCreatePostPollTitleBlankAlertText: 'Rubriken kan inte vara tom!',
  blogsCreatePostPollOptionBlankAlertText: 'Alternativet kan inte vara tomt!',
  blogsCreatePostPollLongTitleAlertText: 'Rubriken får innehålla högst {length} tecken',
  blogsCreatePostPollLongOptionAlertText: 'Alternativet får innehålla högst {length} tecken',
  blogsCreatePostPollEditOptionTitle: 'Redigera enkät',
  blogsCreatePostPollRemoveOptionTitle: 'Ta bort enkät',
  blogsPostPollInfoVotesText: 'röster',
  blogsPostPollInfoEditVoteText: 'Redigera röst',
  blogsPostPollFinishPollText: 'Avsluta enkät',
  blogsPostPollFinishedPollText: 'Avslutad',
  blogsPostPollInProgresslText: 'Pågående',
  blogsFinishPollCurtainTitle: 'Avsluta enkät',
  blogsFinishPollCurtainText: 'Användarna kommer inte kunna rösta efter att enkäten har avslutats.',
  blogsFinishPollCurtainCancelButtonTitle: 'Avbryt',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Bekräfta',
  blogsPollInfoPollVotesCurtainTitle: 'Enkätresultat',
  blogsEditPostCurtainTitle: 'Redigera inlägg',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Skriv din text här...',
  blogsEditPostCurtainSaveButtonTitle: 'Spara',
  blogsEditPostSavedAlertText: 'Inlägget sparades!',
  blogsError: 'Något gick fel!',
  blogsAt: 'kl',
  blogsSeeMore: 'Se mer...',
  blogsMaxAttachments: 'Du har överskridit max antal bilagor. Max bilagor är {length}',
  blogsReply: 'Svara',
  blogsAddCover: 'Lägg till omslagsbild'
}
